<template>
    <div>
        <iframe
                id="my_iframe"
                class="review_css"
                :src="url"
                scrolling="yes"
                style="border: 1px; box-shadow: none;"
                :width="width"
                :height="height"></iframe>
    </div>
</template>

<script>
    export default {
        name: "Wp_jd_getlink",
        props: {
            url: {
                type: String,
                default: 'http://a.wapg.cn/weweb/'
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '600px'
            }
        },
        mounted() {
            const my_iframe = document.getElementById('my_iframe');

            let that = this;
            if (my_iframe.attachEvent) {
                my_iframe.attachEvent("onload", function () {
                    that.$log("====iframe is now loaded. 11====");
                });
            } else {
                my_iframe.onload = function () {
                    that.$log("====iframe is now loaded. 22====");
                    that.$log(my_iframe);
                    that.$log(my_iframe.src);
                    that.$log(my_iframe.contentWindow);
                };
                my_iframe.onloadstart = function () {
                    that.$log("====iframe start load ====");
                };
                my_iframe.onloadend = function () {
                    that.$log("====iframe load end ====");
                }
            }
        }
    }
</script>

<style scoped>

</style>